export default __webpack_public_path__ + "static/media/ic_services_b.8d70150d.svg";